import { render, staticRenderFns } from "./EducationItem.htm?vue&type=template&id=1a290850&scoped=true&"
import script from "./EducationItem.ts?vue&type=script&lang=js&"
export * from "./EducationItem.ts?vue&type=script&lang=js&"
import style0 from "./EducationItem.scss?vue&type=style&index=0&id=1a290850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a290850",
  null
  
)

export default component.exports